import styled from '@emotion/styled';
import { Modal, Stack } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  width: 515,
});

export const StyledContentStack = styled(Stack)({
  overflowY: 'auto',
  maxHeight: 380,
  flex: 1,
});
